<template>
  <label ref="$input" :class="['bear-date-picker', { disabled: disabled, isString }]" autocomplete="off">
    <span v-for="(v, i) in words" :key="i" :class="['date-word', { 'is-space': isSpace(format[i]), 'is-number': isNumber(format[i])}]">{{ v }}</span>
    <!-- <pre>{{text}}</pre> -->
    <el-date-picker
      v-if="!disabled"
      ref="$datePicker"
      class="hidden-date-picker"
      v-model="value"
      :type="type"
      @change="handleChange"></el-date-picker>
    <el-icon v-if="value && !disabled" class="icon-date-close" @click="clearDate"><circle-close /></el-icon>
  </label>
</template>
<script>
import { CircleClose } from "@element-plus/icons-vue";
import utils from "../../common/js/utils";
export default {
  name: "BearDatePicker",
  components: {
    CircleClose,
  },
  props: {
    isString: {
      default: false,
    },
    modelValue: {
      type: [Object, String],
      default() {
        return null;
      },
    },
    format: {
      type: String,
      default: "yyyy-MM-dd",
    },
    valueFormat: {
      type: String,
      default: "yyyy-MM-dd HH:mm:ss",
    },
    type: {
      type: String,
      default: "date",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    text() {
      if (this.value) {
        return utils.DateFormat(this.format, this.value);
      } else {
        return this.format.replace(/[yMdHms]/g, " ");
      }
    },
    words() {
      return this.text.split("");
    },
  },
  data() {
    return {
      value: null,
    };
  },
  mounted() {
    this.setValue(this.modelValue);
  },
  methods: {
    isSpace(v) {
      return /\s/.test(v);
    },
    isNumber(v) {
      return /\w/.test(v);
    },
    handleChange(value) {
      if (value) {
        if (this.isString) {
          this.$emit("update:modelValue", utils.DateFormat(this.valueFormat, value));
        } else {
          this.$emit("update:modelValue", {
            $date: value.getTime(),
          });
        }
      } else {
        this.$emit("update:modelValue", null);
      }
      this.emitChange();
    },
    clearDate() {
      this.$emit("update:modelValue", null);
      this.emitChange();
    },
    emitChange() {
      this.$emit("change");
    },
    setValue(value) {
      if (value) {
        if (this.isString) {
          this.value = new Date(value);
        } else {
          this.value = new Date(value.$date);
        }
      } else {
        this.value = null;
      }
    },
  },
  watch: {
    modelValue(value) {
      this.setValue(value);
    },
  },
};
</script>
<style lang="scss" scoped>
.bear-date-picker {
  display: inline-block;
  position: relative;
  z-index: 1;
  text-indent: 0;
  word-break: break-all;
  line-height: 1;
  padding: 0px 5px 0;
  width: auto;
  min-width: 100px;
  cursor: pointer;
  text-align: left;
  outline: none;
  color: #2393e4;
  &.disabled {
    .date-word {
      background: #eee;
      cursor: not-allowed;
    }
  }
  &.isString {
    min-width: 65px;
  }
}
.icon-date-close {
  color: #a8abb2;
  vertical-align: text-bottom;
  cursor: pointer;
}
.date-word {
  font-size: larger;
  padding: 5px 0;
}
.is-number {
  white-space: pre;
  border-bottom: 1px solid black;
}
</style>
<style lang="scss">
.tender-form-item {
  .hidden-date-picker {
    width: 0 !important;
    height: 16px;
    overflow: hidden;
    vertical-align: text-bottom;
  }
  .is-error {
    .bear-date-picker {
      .is-number {
        border-bottom: 1px solid red;
      }
      & + .el-form-item__error {
        position: relative;
        display: none;
        padding: 5px 5px;
        background: #efdede;
        border-bottom: 1px solid red;
        border-radius: 0 3px 0 0;
      }
    }
  }
}
</style>